import React from "react";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { degrees } from "../../portfolio";
import "./Educations.css";

function Educations(props) {
  const theme = props.theme;

  return (
    <div className="main" id="educations">
      <div className="educations-header-div">
        {/* <Fade bottom duration={2000} distance="20px"> */}
          <h1 className="educations-header" style={{ color: theme.text }}>
            Qualifications
          </h1>
        {/* </Fade> */}
      </div>
      <div className="educations-body-div">
        {degrees.degrees.map((degree, index) => {
          return (
            <DegreeCard key={"degree-" + index} degree={degree} theme={theme} />
          );
        })}
      </div>
    </div>
  );
}

export default Educations;
